import axios from "axios";
import { useState } from "react";
interface Props{
    filename: string;
    url: string
}
const useDowload = ({filename, url}:Props) => {
    const [isLoadingDw, setIsLoadingDw] = useState<boolean>(false)
    const [error,setError] = useState<boolean>(false)
    const onDownload =() =>{
        setIsLoadingDw(true)
        axios({
          url,
          method:'GET',
          responseType: 'blob'
        })
        .then((response)=>{
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url;
            link.setAttribute('download',filename)
            document.body.appendChild(link)
            link.click()
            setIsLoadingDw(false)
        })
        .catch(()=>{
            setIsLoadingDw(false)
            setError(true)
        })
    }
    return{isLoadingDw,error,onDownload}
}

export default useDowload